import api from "./api";

export const postCustomer = async (body) => {
  return api
    .post({
      endpoint: "/own/create/customers",
      port: process.env.REACT_APP_PORT_CUST,
      body,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
